import React from "react";
import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { TEAM_ACTIONS } from "../enums";
import {
    INBOX_SETTINGS_READ_PERMISSION,
    TEAM_DELETE_PERMISSION,
} from "../../../permissions";
const { VIEW_TEAM, DELETE_TEAM } = TEAM_ACTIONS;

const TeamDropdown = ({ team, handleActionModal }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal(value, team)}
            options={[
                {
                    value: VIEW_TEAM,
                    label: "View Team",
                    baseResources: INBOX_SETTINGS_READ_PERMISSION,
                },
                {
                    value: DELETE_TEAM,
                    label: "Delete Team",
                    baseResources: TEAM_DELETE_PERMISSION,
                },
            ]}
        />
    );
};

export default TeamDropdown;
